import { StyleDictionary } from "pdfmake/interfaces";

export const basicStyles: StyleDictionary = {
	header: {
		bold: true,
		fontSize: 16,
	},
	label: {
		color: "gray",
	},
	topHeader: {
		italics: true,
		fontSize: 10,
		color: "gray",
		alignment: "right",
	},
	defaultStyle: {
		fontSize: 11,
		lineHeight: 1.5,
	},
	warningText: {
		fontSize: 10,
		color: "#c2410c",
		bold: true,
	},
	errorText: {
		fontSize: 10,
		color: "#b91c1c",
		bold: true,
	},
	footer: {
		fontSize: 9,
		alignment: "center",
		margin: [0, 10, 0, 0],
	},
};

export const tableLayout = {
	hLineColor: "lightgray",
	vLineWidth: function () {
		return 0;
	},
	paddingBottom: function () {
		return 5;
	},
	paddingTop: function () {
		return 5;
	},
	paddingLeft: function (columnIndex: number) {
		return columnIndex > 0 ? 50 : 4;
	},
};
